// extracted by mini-css-extract-plugin
export default {"container":"MusicPlayer_container__m-Cc9","player":"MusicPlayer_player__4xiGG"};